import {
  EXCLUDED_ROUTES,
  INCLUDED_ROUTES,
  POPUP_TYPE,
} from '../LeadCollectionPopup.constants'

type ExtractStringValues<T> = T extends string
  ? T
  : T extends object
    ? { [K in keyof T]: ExtractStringValues<T[K]> }[keyof T]
    : never

type ExcludedRoutes = ExtractStringValues<typeof EXCLUDED_ROUTES>
type IncludedRoutes = ExtractStringValues<typeof INCLUDED_ROUTES>
type RouteName = ExcludedRoutes | IncludedRoutes
type RouteValue = string | Record<string, unknown>
type PopupTypeValue = (typeof POPUP_TYPE)[keyof typeof POPUP_TYPE]

export function extractRouteNames(
  routeObject: Record<string, unknown>,
): RouteName[] {
  return Object.values(routeObject).flatMap((value) => {
    if (typeof value === 'string') {
      return [value]
    }
    if (typeof value === 'object' && value !== null) {
      return extractRouteNames(value as Record<string, RouteValue>)
    }

    return []
  })
}

export function isExcluded(routeName: RouteName) {
  return extractRouteNames(EXCLUDED_ROUTES).includes(routeName)
}

export function isIncluded(popupType: PopupTypeValue, routeName: RouteName) {
  const includedRoutes = INCLUDED_ROUTES[popupType]

  return extractRouteNames(includedRoutes).includes(routeName)
}
